// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1IAng","title":"FrontImage_title__2PXas"};